import {
  CreateBase,
  Form,
  useGetIdentity,
  useRedirect,
  useTranslate,
} from "ra-core";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

import { firstOpenStage } from "../deals/stages";
import { FormToolbar } from "../layout/FormToolbar";
import { ALL_PROJECTS, useCurrentProject } from "../projects/useCurrentProject";
import { LeadInputs } from "./LeadInputs";

/** «Новый лид»: in the project chosen in the header, on its first stage. */
export const LeadCreate = ({ open }: { open: boolean }) => {
  const redirect = useRedirect();
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const { currentId, pipelinesOf, stagesOf } = useCurrentProject();
  const projectId = currentId === ALL_PROJECTS ? null : currentId;
  const stages =
    projectId != null ? stagesOf(pipelinesOf(projectId, "lead")[0]?.id) : [];

  const close = () => redirect("/leads");

  return (
    <Dialog open={open} onOpenChange={() => close()}>
      <DialogContent className="lg:max-w-3xl overflow-y-auto max-h-9/10 top-1/20 translate-y-0">
        <CreateBase
          resource="leads"
          redirect={false}
          mutationOptions={{ onSuccess: close }}
        >
          <DialogTitle className="text-xl font-semibold">
            {translate("resources.leads.action.create")}
          </DialogTitle>
          <Form
            defaultValues={{
              source: "call",
              sales_id: identity?.id,
              project_id: projectId ?? undefined,
              stage_id: stages.length ? firstOpenStage(stages).id : undefined,
            }}
          >
            <LeadInputs chooseProject={projectId == null} />
            <FormToolbar />
          </Form>
        </CreateBase>
      </DialogContent>
    </Dialog>
  );
};
